import React from 'react';
import { withStateHandlers } from 'recompose';

import '../../css/text-editor.less';

const TextEditor = ({ isEditing, setIsEditing, onChange, text = '', isMutiline = false }) => (
    <span className="text-editor flex" tabIndex="0" onFocus={() => setIsEditing(true)}>
        {
            isEditing
                ? isMutiline
                    ? (
                        <textarea
                            className="flex-grow text-padding text-editor-input"
                            autoFocus={true}
                            value={text}
                            onChange={onChange}
                            onBlur={() => setIsEditing(false)}
                        />
                    )
                    : (
                        <input
                            className="flex-grow text-padding text-editor-input"
                            autoFocus={true}
                            value={text}
                            onChange={onChange}
                            onBlur={() => setIsEditing(false)}
                        />
                    )
                : <span className="flex-grow text-padding text-editor-display">{text}</span>
        }
        {
            isEditing
                ? null
                : (
                    <button className="btn-icon flex-child-right" onClick={() => setIsEditing(true)}>
                        <span className="glyphicon glyphicon-pencil" />
                    </button>
                )
        }
    </span>
);

export default withStateHandlers(
    ({ isEditing = false }) => ({ isEditing }),
    { setIsEditing: () => newValue => ({ isEditing: newValue }) },
)(TextEditor);
